import React, { useEffect } from 'react';
import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonPage, IonRefresher, IonRefresherContent, IonTitle, IonToolbar } from '@ionic/react';
import { notifications } from 'ionicons/icons';
import { useHistory } from 'react-router';
import { observer } from 'mobx-react';
import authStore from '../../store/auth';
import dashboardStore from '../../store/dashboard';
import StatisticsCard from './StatisticsCard';

const Dashboard: React.FC = observer(() => {
    const history = useHistory();

    useEffect(() => {
        authStore.checkAuth();
        dashboardStore.getDashboardReport();
    }, []);

    return (
        <IonPage>
            <IonContent fullscreen>
                <IonHeader>
                    <IonToolbar color="primary">
                        <IonTitle>Sopipack Owner App</IonTitle>
                        <IonButtons slot="secondary">
                            <IonButton color='light'>
                                <IonIcon slot="icon-only" icon={notifications}></IonIcon>
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding" style={{ '--background': '#f8f9fa' }}>
                    <IonRefresher slot="fixed" onIonRefresh={async (event) => {
                        await dashboardStore.getDashboardReport();
                        event.detail.complete();
                    }}>
                        <IonRefresherContent></IonRefresherContent>
                    </IonRefresher>
                    <StatisticsCard data={dashboardStore.dashboard_data} loading={dashboardStore.loading} />
                </IonContent>
            </IonContent>
        </IonPage>
    );
});

export default Dashboard;
